import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cross",
  "use": "icon-cross-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-cross\"><defs><style type=\"text/css\"></style></defs><path d=\"M791.2 536.48l-45.12 45.28L820.16 656h-153.12l-114.24-144 114.24-144h153.12l-74.08 74.24 45.12 45.12L896 382.72l45.28-45.28L896 292.16l-104.8-104.64-45.12 45.28L817.28 304H636.16L512 460.48 387.84 304H96v64h260.96l114.24 144-114.24 144H96v64h291.84L512 563.52 636.16 720h181.12l-71.2 71.2 45.12 45.28L896 731.84l45.28-45.28L896 641.28l-104.8-104.8z\" fill=\"#333333\" p-id=\"1979\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/cross.svg
// module id = 9pzy
// module chunks = 54